import { CLIENT_PAY_NORMALISATION_MAX_PDF_BYTES } from "../config";

/** Shown when MYOB IMS is selected but the file is not a PDF (CN-04 / R-APP-2). */
export const CLIENT_PAY_WRONG_FILE_TYPE_MESSAGE =
  "This file type is not supported for MYOB IMS in v1. Upload a combined payslip PDF (text-based, not a scan).";

export const CLIENT_PAY_PDF_TOO_LARGE_MESSAGE =
  "The PDF is too large. Upload a smaller combined payslip export (maximum 20 MB).";

export function isClientPayPdfFile(file: File): boolean {
  return file.name.toLowerCase().endsWith(".pdf");
}

/** Returns a user-facing rejection message, or `null` when the file is acceptable. */
export function getClientPayPdfFileRejection(file: File): string | null {
  if (!isClientPayPdfFile(file)) {
    return CLIENT_PAY_WRONG_FILE_TYPE_MESSAGE;
  }
  if (file.size > CLIENT_PAY_NORMALISATION_MAX_PDF_BYTES) {
    return CLIENT_PAY_PDF_TOO_LARGE_MESSAGE;
  }
  return null;
}
